const rankingItems = [
  {
    rank: 1,
    title: '暑期最受期待古装剧开播，首日播放量破纪录',
    heat: '127.6万',
    tag: '影视',
    trend: 'up',
  },
  {
    rank: 2,
    title: '顶流男星新综艺首秀，话题阅读量超5亿',
    heat: '98.3万',
    tag: '综艺',
    trend: 'up',
  },
  {
    rank: 3,
    title: '知名导演新片阵容官宣，豪华卡司引爆期待',
    heat: '85.1万',
    tag: '电影',
    trend: 'up',
  },
  {
    rank: 4,
    title: '双顶流恋情实锤，全网热搜持续霸榜',
    heat: '72.9万',
    tag: '八卦',
    trend: 'hot',
  },
  {
    rank: 5,
    title: '现象级网剧续作开机，原班人马全数回归',
    heat: '61.4万',
    tag: '剧集',
    trend: 'new',
  },
];

function getRankStyle(rank: number) {
  if (rank === 1) return 'bg-primary-500 text-background-50';
  if (rank === 2) return 'bg-primary-400 text-background-50';
  if (rank === 3) return 'bg-accent-400 text-background-50';
  return 'bg-secondary-300 text-foreground-700';
}

function getTrendIcon(trend: string) {
  if (trend === 'up') return <i className="ri-arrow-up-line text-primary-500"></i>;
  if (trend === 'hot') return <i className="ri-fire-line text-primary-500"></i>;
  return <i className="ri-sparkling-line text-accent-500"></i>;
}

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
              热度榜单
            </h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
              实时更新的吃瓜热度排行，看看今天什么最火
            </p>
          </div>

          <div className="space-y-3">
            {rankingItems.map((item) => (
              <div
                key={item.rank}
                className="flex items-center gap-4 bg-background-100 rounded-xl p-4 md:p-5 cursor-pointer transition-all duration-200 hover:scale-[1.01] border border-background-200/60"
              >
                <div
                  className={`w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-lg font-heading font-bold text-sm md:text-base flex-shrink-0 ${getRankStyle(item.rank)}`}
                >
                  {item.rank}
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm md:text-base font-medium text-foreground-800 truncate">
                    {item.title}
                  </h3>
                  <span className="text-xs text-foreground-500 mt-1 inline-block">
                    {item.tag}
                  </span>
                </div>
                <div className="flex items-center gap-2 flex-shrink-0">
                  <span className="text-xs md:text-sm font-medium text-primary-600 whitespace-nowrap">
                    {item.heat}
                  </span>
                  <span className="w-5 h-5 flex items-center justify-center">
                    {getTrendIcon(item.trend)}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}